import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import downloadSVG from '@plone/volto/icons/download.svg';

import { defineMessages, useIntl } from 'react-intl';
import eyeSVG from '../../../assets/icons/eye.svg';
import Icon from '../../Icon/Icon';

const messages = defineMessages({
  viewDocument: {
    id: 'viewDocument',
    defaultMessage: 'View document',
  },
  downloadDocument: {
    id: 'downloadDocument',
    defaultMessage: 'Download document',
  },
});

const JuntsFileVariantItem = ({ item }) => {
  const intl = useIntl();
  let href = item['@id'] || '';

  function getLink() {
    if (isInternalURL(href)) {
      return (
        <UniversalLink href={flattenToAppURL(href)} className="item">
          <Icon
            name={eyeSVG}
            size="1.5rem"
            title={intl.formatMessage(messages.viewDocument)}
          />
        </UniversalLink>
      );
    } else if (href) {
      return (
        <UniversalLink href={href} openLinkInNewTab className="item">
          <Icon
            name={eyeSVG}
            size="1.5rem"
            title={intl.formatMessage(messages.viewDocument)}
          />
        </UniversalLink>
      );
    }
  }
  return (
    <>
      <div className="junts-file-variant-item">
        <div className="junts-file-variant-item-title">{item.title}</div>
        <div className="junts-file-variant-icons">
          {getLink()}

          {item?.file?.download && (
            <a
              href={flattenToAppURL(item?.file?.download || '')}
              download
              className="item"
            >
              <Icon
                name={downloadSVG}
                size="1.5rem"
                title={intl.formatMessage(messages.downloadDocument)}
              />
            </a>
          )}
        </div>
      </div>
    </>
  );
};

export const JuntsFileVariant = ({ items }) => {
  return (
    <div>
      <ul className="junts-file-variant">
        {items.map((item) => (
          <li key={item['@id']}>
            <JuntsFileVariantItem item={item} />
          </li>
        ))}
      </ul>
    </div>
  );
};
